import { render, staticRenderFns } from "./LiquidationPayment.vue?vue&type=template&id=52d20388"
import script from "./LiquidationPayment.vue?vue&type=script&lang=js"
export * from "./LiquidationPayment.vue?vue&type=script&lang=js"
import style0 from "./LiquidationPayment.vue?vue&type=style&index=0&id=52d20388&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports